import React from 'react'
import { Link } from 'react-router-dom'


const Footer = () => {
  return (
    <footer id="footer" className="container">
      <div className="content">
        <nav>
          <ul>
            <li>
              <a href="https://www.facebook.com/Antibully-Clothing-Company-1488950677848741/" target="_blank">
                <i className="fa fa-facebook"></i> Facebook
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/antibullyclothing/" target="_blank">
                <i className="fa fa-instagram"></i> Instagram
              </a>
            </li>
            {/* <li>
              <a href="https://twitter.com/comfybebe" target="_blank">
                <i className="fa fa-twitter"></i> Twitter
              </a>
            </li> */}
            <li>
              <a href="https://www.etsy.com/shop/ComfyBebe?ref=l2-shopheader-name" target="_blank">
                <i class="fa fa-etsy"></i> Etsy
              </a>
            </li>
            <li>
              <a href="mailto:Info@antibullyclothing.com">
                <i className="fa fa-paper-plane"></i> Email
              </a>
            </li>
          </ul>
        </nav>
        <p>© Antibully Clothing</p>
      </div>
    </footer>
  )
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js